import { fieldMap, stateNames } from './mappings'

var Data = {
  stats: {
    result: null,
    error: "",
    fieldMap,
    stateNames,
    fetch: (options={}) => {
      const {
        geo='index',
      } = options
      return m.request({
        method: "GET",
        url: "/data/",
        params: { key: geo }
      }).then((items) => {
        Data.stats.result = items
        Data.stats.sortField = {}
        return items
      }).catch((e) => {
        Data.stats.error = e.message
        return e
      })
    },
    sortField: {},
    toggleSort: field => {
      const me = Data.stats
      if(me.sortField[field]) {
        me.sortField[field] *= -1
      } else {
        me.sortField = { [field]: 1 }
      }
      const direction = me.sortField[field]
      me.result.data.sort((a, b) => {
        if(!isNaN(a[field])) {
          return direction * (b[field] - a[field])
        }
        if(a[field].trim().endsWith('%')) {
          return direction * (parseFloat(b[field]) - parseFloat(a[field]))
        }
        else {
          return direction * ('' + a[field]).localeCompare(b[field]);
        }
      })
    }
  },
  counties: {
    result: null,
    error: "",
    fetch: (options={}) => {
      const {
        state='FL',
      } = options
      return m.request({
        method: "GET",
        url: "/data/county",
        params: { state }
      }).then((items) => {
        Data.counties.result = items
        return items
      }).catch((e) => {
        Data.counties.error = e.message
        return e
      })
    }
  }
}

export { Data }
